module.exports = __webpack_public_path__ + "static/media/koja.98b7519b.mp3";